<template>
	<el-drawer :modal="false" title="All Remark " :visible.sync="is_visible" class="drawer-remark-list" size="60%"
		@closed="hide">
		<b-container>
			<b-row>
				<b-col cols="12" v-loading="is_loading_table">
					<div class="table-listings">
						<el-table ref="remarkTable" :data="tableData" style="width: 100%" :show-header="false">
							<el-table-column label="Content" min-width="400">
								<template slot-scope="scope">
									<div class="top-line" v-html="scope.row.content"></div>
									<small>{{ scope.row.created_at || '-' | dateFormatString }}</small>
								</template>
							</el-table-column>
							<el-table-column label="" width="70">
								<template slot-scope="scope">
									<el-dropdown trigger="click" style="cursor: pointer">
										<p class="el-dropdown-link mb-0 top-line">
											<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
										</p>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item @click.native="editItem(scope.row)">
												<!-- Eye Icon -->
												<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
													<path fill="#13663E"
														d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
												</svg>
												Edit
											</el-dropdown-item>
											<el-dropdown-item @click.native="removeItem(scope.row.rmrk_id)">
												<span class="text-danger">
													<!-- Trash-Can Icon -->
													<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
														<path fill="#DF3030"
															d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
													</svg>
													Delete
												</span>
											</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</b-col>
			</b-row>
			<ModalAddRemark ref="modal_add_remark" />
		</b-container>
	</el-drawer>
</template>

<script>
import { cloneDeep } from 'lodash'
import { Table, TableColumn, Drawer, Button, Dropdown, DropdownItem, DropdownMenu, } from 'element-ui'
import swal from 'sweetalert2';
import ModalAddRemark from '@/views/CreditLoanCase/Modals/ModalAddRemark';
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore';

export default {
	components: {
		ModalAddRemark,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Drawer.name]: Drawer,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Button.name]: Button
	},
	data() {
		return {
			is_visible: false,
			is_loading_table: false,
			tableData: []
		}
	},
	watch: {
		'activeRemarks': {
			handler(newValue) {
				if(_gHlp.isEmpty(newValue)){
					this.tableData = cloneDeep(newValue)
				}
			},
			immediate: true
		}
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeRemarks']),
	},
	methods: {
		...mapActions(useLoanCaseStore, ['updateRemark','deleteRemark']),
		show() {
			this.is_visible = true;
			this.tableData = cloneDeep(this.activeRemarks);
		},
		hide() {
			this.is_visible = false;
			this.is_loading_table = false;
			this.tableData = [];
		},
		editItem(item){
			this.$refs.modal_add_remark.show(item)
		},
		removeItem(id) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					this.is_loading_table = true;
					this.deleteRemark(id).then(resp => {
						this.is_loading_table = false
					}).catch(err => {
						this.is_loading_table = false
					})
				}
			});
		}
	}
}
</script>